module.exports = __webpack_public_path__ + "static/media/harpe.b875f7a0.jpg";